namespace GeniuzPOS.InitialData {
    export namespace PsDiscCouponTypeService {
        export const baseUrl = 'InitialData/PsDiscCouponType';

        export declare function Create(request: Serenity.SaveRequest<PsDiscCouponTypeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsDiscCouponTypeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsDiscCouponTypeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsDiscCouponTypeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsDiscCouponType/Create",
            Update = "InitialData/PsDiscCouponType/Update",
            Delete = "InitialData/PsDiscCouponType/Delete",
            Retrieve = "InitialData/PsDiscCouponType/Retrieve",
            List = "InitialData/PsDiscCouponType/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsDiscCouponTypeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
